export const TopoBackground = ({ className = "", stroke = "#c8a452", opacity = 0.12 }) => (
  <svg
    aria-hidden="true"
    className={`pointer-events-none absolute inset-0 h-full w-full ${className}`}
    preserveAspectRatio="xMidYMid slice"
    viewBox="0 0 1200 600"
    fill="none"
  >
    <g stroke={stroke} strokeWidth="1.5" opacity={opacity} fill="none">
      <path d="M-50 120 C 200 40, 400 200, 650 120 S 1050 40, 1300 140" />
      <path d="M-50 180 C 200 100, 420 260, 660 180 S 1050 100, 1300 200" />
      <path d="M-50 240 C 220 160, 440 320, 680 240 S 1060 160, 1300 260" />
      <path d="M-50 320 C 240 240, 460 400, 700 320 S 1080 240, 1300 340" />
      <path d="M-50 400 C 260 320, 480 480, 720 400 S 1100 320, 1300 420" />
      <path d="M-50 480 C 280 400, 500 560, 740 480 S 1120 400, 1300 500" />
      <ellipse cx="640" cy="300" rx="120" ry="70" />
      <ellipse cx="640" cy="300" rx="70" ry="40" />
    </g>
  </svg>
);
